<script setup lang="ts">

import { faXmark } from '@fortawesome/pro-solid-svg-icons'

import { AppText } from '@shared/ui/typography'
import { DropZoneArea } from '@shared/ui/other'
import { CardAdmin } from '@shared/ui/cards'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'

import { useImportTutorPayments, TUTOR_PAYMENTS_ACCEPT } from '../../../model/tools/tutor-payments/import-tutor-payments.hook'

defineOptions({
  name: 'ImportTutorPaymentsUploader',
})

const {
  refFile,
  refIsUploading,
  refProgress,
  refError,
  selectFiles,
  submit,
  reset,
} = useImportTutorPayments()
</script>

<template>
  <CardAdmin
    title="Import tutor payments"
    subtitle="Upload a CSV file to import tutor payments."
  >
    <template #header>
      <BtnPrimary
        :text="refIsUploading ? 'Importing…' : 'Import'"
        color="blue"
        :disabled="!refFile || refIsUploading"
        @click="submit"
      />
    </template>

    <div class="import-tutor-payments">
      <DropZoneArea
        :accept="TUTOR_PAYMENTS_ACCEPT"
        :multiple="false"
        :disabled="refIsUploading"
        title="Drag & drop a tutor payments file here"
        browse-text="Browse file"
        @files="selectFiles"
      />

      <div
        v-if="refFile"
        class="import-tutor-payments__file"
      >
        <AppText name="body2-medium">
          {{ refFile.name }}
        </AppText>
        <BtnIcon
          :icon="faXmark"
          view="transparent"
          :disabled="refIsUploading"
          @click="reset"
        />
      </div>

      <AppText
        v-if="refIsUploading"
        name="body2"
        color="slate-500"
      >
        Uploading… {{ refProgress }}%
      </AppText>

      <AppText
        v-if="refError"
        name="body2"
        color="red-500"
      >
        {{ refError }}
      </AppText>
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./ImportTutorPaymentsUploader.scss" />
